import { appendQueryString } from "../../../api/appendQueryString";
import type { Api } from "../../../api/subApis/api.types";
import type { ActiveUser } from "../../UserManagement/UserManagement.types";

const expressOnboardingApi = {
  base: {
    url: () => "/api/express-onboarding-generators",
    key: () => ["expressOnboarding"]
  },
  siteTodoStatus: {
    url: (user_id: ActiveUser["id"] | null) =>
      appendQueryString(
        `${expressOnboardingApi.base.url()}/onboarding-status`,
        { user_id: user_id }
      ),
    key: (user_id: ActiveUser["id"] | null) => [
      ...expressOnboardingApi.base.key(),
      "siteTodoStatus",
      user_id
    ]
  },
  generators: {
    url: (user_id: ActiveUser["id"] | null) =>
      appendQueryString(expressOnboardingApi.base.url(), {
        user_id: user_id
      }),
    key: (user_id: ActiveUser["id"] | null) => [
      ...expressOnboardingApi.base.key(),
      "generators",
      user_id
    ]
  },
  generator: {
    url: (id: number) => `${expressOnboardingApi.base.url()}/${id}/`,
    key: (id: number) => [...expressOnboardingApi.base.key(), "generators", id]
  }
} satisfies Api;

export { expressOnboardingApi };
